import React, { memo, useMemo } from 'react';
import styles from './form.module.scss';
import Input from '../../../../../shared/components/Input';
import TextArea from '../../../../../shared/components/TextArea';
import CustomSelect from '../../../../../shared/components/CustomSelect';
import AutoCompleteUsers from '../../../AutoCompleteUsers';
import AutoCompleteDevices from '../../../AutoCompleteDevices';
import AutoCompleteSimcard from '../../../AutoCompleteSimcard';
import CustomSwitch from '../../../../../shared/components/CustomSwitch';
import Vehicle from './subComponents/Vehicle';
import Client from './subComponents/Client';
import { useTranslation } from 'react-i18next';
import { cps } from 'redux-saga/effects';
import {storeStatusesGps, installationStatusesGps, deactivatedStatusesGps, assignedStatusesGps} from '../../../../../shared/helpers/constants'

const Form = ({
    name,
    handleName,
    handleAssigned,
    observation,
    handleObservation,
    assigned,
    enabled,
    handleEnabled,
    status,
    handleStatus,
    protocol,
    handleProtocol,
    simcard,
    handleSimcard,
    device,
    handleDevice,
    defaultUsersOpt,
    statusesOpt,
    statusesFetching,
    idGpsDevices,
    defaultProtocolOptions,
    gpsDevice
}) => {
    const { t } = useTranslation(['home', 'devices', 'users', 'notification']);
    
    const statusOptions = useMemo(()=> {
        if(installationStatusesGps.includes(status.value)){
            return statusesOpt.filter(statusOpt => storeStatusesGps.includes(statusOpt.value))
        }
        if(assignedStatusesGps.includes(status.value)) {
            statusesOpt = statusesOpt.filter(
                statusValue => assignedStatusesGps.includes(statusValue.value) || deactivatedStatusesGps.includes(statusValue.value)
            )
        }
        return statusesOpt.filter(statusOpt => !installationStatusesGps.includes(statusOpt.value)
    )},[statusesOpt,status]);
    
    const simcardValueExist = useMemo(() => typeof gpsDevice.simcard === 'object' && !Array.isArray(gpsDevice.simcard),[gpsDevice]);
    const deviceValueExist = useMemo(() => typeof gpsDevice.device === 'object' && !Array.isArray(gpsDevice.device),[gpsDevice]);

    return (
        <div className={styles.divRow}>
            <div className={`${styles.f70} ${styles.configuration}`}>
                <div className={`${styles.divRow} ${styles.marginBottom} ${styles.inputsPadding}`}>
                    <Input
                        label={t('home:name')}
                        placeholder={t('home:name')}
                        value={name}
                        onChange={handleName}
                        required={[true, { minLength: 1 }]}
                        messageError={t('notification:enter_name')}
                    />
                    <CustomSelect
                        label={t('home:protocol_version')}
                        placeholder={t('home:protocol_version')}
                        value={protocol}
                        onChange={handleProtocol}
                        options={defaultProtocolOptions}
                        required={[true, { minLength: 1 }]}
                        messageError={t('notification:choose_protocol')}
                    />
                </div>

                <div className={`${styles.divRow} ${styles.marginBottom} ${styles.inputsPadding}`}>
                    <AutoCompleteSimcard
                        label={t('home:simcard')}
                        placeholder={t('home:simcard')}
                        isDisabled={simcardValueExist}
                        simcardValue={simcard}
                        handleSimcard={handleSimcard}
                        defaultOptions={defaultUsersOpt}
                        required={[true, { minLength: 1 }]}
                        messageError={t('notification:choose_simcard')}
                    />
                    <AutoCompleteDevices
                        label={t('home:device')}
                        placeholder={t('home:device')}
                        isDisabled={deviceValueExist}
                        deviceValue={device}
                        handleDevice={handleDevice}
                        defaultOptions={defaultUsersOpt}
                        required={[true, { minLength: 1 }]}
                        messageError={t('notification:choose_device')}
                    />
                </div>

                <div className={`${styles.divRow} ${styles.marginBottom} ${styles.inputsPadding}`}>
                    <TextArea
                        label={t('home:observation')}
                        placeholder={t('home:observation')}
                        value={observation}
                        onChange={handleObservation}
                        rows={6}
                    />
                </div>

                {
                    typeof idGpsDevices !== "undefined" &&
                    <>
                        <Client />
                        <Vehicle idGpsDevices={idGpsDevices} />
                    </>
                }

            </div>
            <div className={`${styles.f30} ${styles.detail}`}>
                <div className={`${styles.divRow} ${styles.marginBottom} ${styles.inputsPadding}`}>
                    <CustomSwitch
                        label={enabled.label}
                        value={enabled.checked}
                        onChange={handleEnabled}
                    />
                </div>
                <div className={`${styles.divRow} ${styles.marginBottom} ${styles.inputsPadding}`}>
                    <CustomSelect
                        label={t('home:status')}
                        placeholder={t('home:status')}
                        value={status}
                        onChange={handleStatus}
                        options={statusOptions}
                        loading={statusesFetching}
                        required={[true, { minLength: 1 }]}
                        messageError={t('notification:choose_device')}
                        readOnly={typeof idGpsDevices === 'undefined'}
                    />
                </div>
                <div className={`${styles.divRow} ${styles.marginBottom} ${styles.inputsPadding}`}>
                    <AutoCompleteUsers
                        label={t('devices:assigned')}
                        placeholder={t('devices:assigned')}
                        assigned={assigned}
                        handleAssigned={handleAssigned}
                        defaultOptions={defaultUsersOpt}
                    />
                </div>
                <div className={`${styles.divRow} ${styles.marginBottom} ${styles.inputsPadding}`}>
                    <Input
                        label={t('users:phone')}
                        placeholder={t('users:phone')}
                        value={assigned.phone || ""}
                        readOnly
                    />
                </div>

            </div>
        </div>
    );
};

export default memo(Form);